import type { AppointmentWorkflowStatus } from '@/pages/appointments/utils/appointmentWorkflowStatus';
import { calendarStatusToWorkflowStatus } from '@/pages/appointments/utils/appointmentWorkflowStatus';

export type ParticipantAttendancePillColors = {
  backgroundColor: string;
  color: string;
};

/** Pill background/text colors keyed by semantic workflow status. */
export const PARTICIPANT_ATTENDANCE_PILL_COLORS: Record<
  AppointmentWorkflowStatus,
  ParticipantAttendancePillColors
> = {
  requested: {
    backgroundColor: 'var(--mantine-color-violet-0)',
    color: 'var(--mantine-color-violet-8)',
  },
  confirmed: {
    backgroundColor: 'var(--mantine-color-green-0)',
    color: 'var(--mantine-color-green-8)',
  },
  /** Deeper green fill than `confirmed`, which is only faintly tinted. */
  completed: {
    backgroundColor: 'var(--mantine-color-green-2)',
    color: 'var(--mantine-color-green-9)',
  },
  cancelled: {
    backgroundColor: 'var(--mantine-color-gray-1)',
    color: 'var(--mantine-color-gray-7)',
  },
  'late-cancelled': {
    backgroundColor: 'var(--mantine-color-orange-0)',
    color: 'var(--mantine-color-orange-8)',
  },
  'no-show': {
    backgroundColor: 'var(--mantine-color-red-0)',
    color: 'var(--mantine-color-red-8)',
  },
};

export function participantAttendancePillColorsForStatus(
  status: string | null | undefined,
): ParticipantAttendancePillColors {
  const workflow = calendarStatusToWorkflowStatus(status);
  return PARTICIPANT_ATTENDANCE_PILL_COLORS[workflow];
}
